let navigate = null;

export const setNavigateHandler = (handler) => {
  navigate = handler;
};

export const redirectToAuth = () => {
  if (navigate) {
    navigate('/auth/sign-up');
  } 
};